module.exports = __webpack_public_path__ + "img/logo-branco-pam.fedc7494.png";